import { createContext } from 'react'

export type TTheme = {
  primaryBackgroundColor?: string
  primaryColor?: string
  [key: string]: any
}
const ThemeContext = createContext<TTheme>({
  primaryBackgroundColor: 'rgb(167, 31, 60)',
  primaryColor: 'white',
})

export default ThemeContext
